import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { State } from './state';
import { environment } from '../environments/environment';
 
const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};
 
@Injectable({
  providedIn: 'root'
})
export class StateService {
	baseUrl = environment.baseUrl;
  private statesUrl = this.baseUrl +'/api/states';  // URL to web api
  constructor( 
    private http: HttpClient
  ) { }
 
  getStates (): Observable<State[]> {
    return this.http.get<State[]>(this.statesUrl)
  }

  
  getState(stateid: number): Observable<State> {
    const url = `${this.statesUrl}/${stateid}`;
    return this.http.get<State>(url);
  }
 
  addState (state: State): Observable<State> {
    return this.http.post<State>(this.statesUrl, state, httpOptions);
  }
 
  deleteState (state: State | number): Observable<State> {
    const id = typeof state === 'number' ? state : state.stateid;
    const url = `${this.statesUrl}/${id}`;
 
    return this.http.delete<State>(url, httpOptions);
  }
 
  updateState (state: State): Observable<any> {
    return this.http.put(this.statesUrl, state, httpOptions);
  }
}